
export const init_app_watchers = function () {
    console.log("EMPTY WATCHERS FOR APP STORE")
}